import React from "react"
import { Card, CardContent, Typography, Box, Button, Chip } from "@mui/material"
import { CalendarToday, Event, Badge, CheckCircle } from "@mui/icons-material"
import InfoIcon from "@mui/icons-material/Info"
import LocationCityIcon from "@mui/icons-material/LocationCity"
import AccessTimeIcon from "@mui/icons-material/AccessTime"

const EventoCard = ({ evento, onSelect, isMobile, seleccionado, readonly = false }) => {
  // Si es readonly, no debe ser clickeable ni mostrar botón
  const isClickeable = !seleccionado && !readonly

  return (
    <Card
      sx={{
        cursor: isClickeable ? "pointer" : "default",
        transition: "transform 0.2s, box-shadow 0.2s",
        border: seleccionado ? "2px solid" : "none",
        borderColor: seleccionado ? "primary.main" : "transparent",
        "&:hover": {
          transform: isClickeable ? "translateY(-4px)" : "none",
          boxShadow: isClickeable ? 6 : seleccionado ? 2 : 1,
        },
      }}
      onClick={isClickeable ? () => onSelect(evento) : undefined}
    >
      <CardContent>
        {seleccionado && (
          <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
            <Chip icon={<CheckCircle />} label="Seleccionado" color="primary" size="small" />
          </Box>
        )}

        <Typography variant={isMobile ? "subtitle1" : "h6"} gutterBottom>
          {evento.extendedProps.empleadoNombre}
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <LocationCityIcon sx={{ fontSize: 18, mr: 1, color: "text.secondary" }} />
          <Typography variant="body2">Localidad: {evento.extendedProps.localidadNombre}</Typography>
        </Box>

        {/* <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <CalendarToday sx={{ fontSize: 18, mr: 1, color: "text.secondary" }} />
          <Typography variant="body2">
            {new Date(evento.start).toLocaleDateString("es-ES", {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </Typography>
        </Box> */}

        {/* <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <Event sx={{ fontSize: 18, mr: 1, color: "text.secondary" }} />
          <Typography variant="body2">
            {new Date(evento.start).toLocaleTimeString("es-ES", {
              hour: "2-digit",
              minute: "2-digit",
            })}{" "}
            -{" "}
            {new Date(evento.end).toLocaleTimeString("es-ES", {
              hour: "2-digit",
              minute: "2-digit",
            })}
          </Typography>
        </Box> */}

        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <Badge sx={{ fontSize: 18, mr: 1, color: "text.secondary" }} />
          <Typography variant="body2">Horario: {evento.extendedProps.horarioDesc}</Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <InfoIcon sx={{ fontSize: 18, mr: 1, color: "text.secondary" }} />
          <Typography variant="body2">Descripción Horario: {evento.extendedProps.plandescri}</Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <AccessTimeIcon sx={{ fontSize: 18, mr: 1, color: "text.secondary" }} />
          <Typography variant="body2">Fecha de entrada: {evento.extendedProps.ejecfecha}</Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <AccessTimeIcon sx={{ fontSize: 18, mr: 1, color: "text.secondary" }} />
          <Typography variant="body2">Hora de entrada: {evento.extendedProps.ejechora}</Typography>
        </Box>

        {/* BOTÓN SOLO SE MUESTRA SI NO ESTÁ SELECCIONADO Y NO ES READONLY */}
        {isClickeable && (
          <Box sx={{ mt: 2, textAlign: "right" }}>
            <Button variant="outlined" size="small">
              Seleccionar
            </Button>
          </Box>
        )}
      </CardContent>
    </Card>
  )
}

export default EventoCard
